<template>
  <div class="">
    <card back>
      <template v-slot:header>
        <h5>ادغام مشتری</h5>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="Fisrt p-2">
                <small>انتخاب مشتری اول </small>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="Second p-2">
                <small>انتخاب مشتری</small>
                <small class="text-warning"> (در ادغام اطلاعات مشتری اول در این مشتری ادغام میشود) </small>
              </div>
            </div>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card },
  data() {
    return {}
  },
}
</script>
<style scoped>
.Fisrt {
  width: 100%;
  border-radius: 8px;
  border: 2px solid burlywood;
}
.Second {
  width: 100%;
  border-radius: 8px;
  border: 2px solid burlywood;
}
</style>
